export abstract class TimeFormatTemplate {
  public static readonly DateYearMonthDay: string = 'YYYYMMDD'
  public static readonly TimeHourMinSecMilliColon: string = 'HH:mm:ss.SSS'
  public static readonly TimeHourMinSecColon: string = 'HH:mm:ss'
  public static readonly DateYearMonthDayHyphen: string = 'YYYY-MM-DD'  // 2015-03-11
}
